<div [hidden]="!showHeader">
<!-- <app-channel-rate-limit-banner *ngIf="channel && demoMode" [channel]="channel" [bannerData]="bannerData" (bannerRefresh)="getRateLimitBanner()"></app-channel-rate-limit-banner> -->

<div class="alert-warning rounded-0 mb-0 d-flex align-items-center justify-content-between flex-wrap nxt-py-14 nxt-px-16" role="status" *ngIf="channel && demoMode">
  <div class="d-flex align-items-center flex-grow-1 nxt-mr-12 nxt-font-14">
    <i class="nxticon-warning-line mr-2 yellow font-medium "></i>
    <span class="nxt-font-14 mr-3">{{ bannerData?.banner_summary }}</span>
    <button type="button" class="btn btn-link p-0 nxt-font-14 font-weight-semibold" (click)="getRateLimitBanner()">
      <i class="fa fa-sync"></i>
    </button>
  </div>
  <div class="d-flex align-items-center nxt-gap-10" >
    <a class="btn-link p-0 nxt-font-14 font-weight-semibold" href="javascript:void(0)" (click)="openDetails()">
      View details
    </a>
    <a class="btn-link p-0 nxt-font-14 font-weight-semibold" [href]="knowMoreLink" target="_blank">
      Know more
    </a>
  </div>
</div>

<!--display P0 alert -->
<!-- <ngb-alert class="alert-p0 alert-full text-center" *ngIf="alertText"
           (close)="closeClick()"> -->
<ngb-alert class="alert-p0 alert-full text-center justify-content-center mb-0" *ngIf="alertText" (close)="closeClick()">
  <i class="icon icon-disabled "></i> &nbsp; <p class="font-weight-semibold" [innerHTML]="alertText"></p>
</ngb-alert>
<!--end-->

<!--display P1 alert -->
<ngb-alert class="alert-p1 alert-full text-center justify-content-center mb-0" *ngIf="alertTextP1" (close)="closeP1Click()">
      <p class="font-weight-semibold" [innerHTML]="alertTextP1"></p>
</ngb-alert>
<!--end-->
<!--display account activation details-->
<ngb-alert class="alert-custom alert-full text-center justify-content-center mb-0" *ngIf="!alertText && showActivation"  [dismissible]="false">
  <!--<ngb-alert class="alert-p0 alert-full text-center" *ngIf="!alertText && showActivation"-->
  <!--(close)="closeActivationClick()">-->
  <!-- <label>{{activationMsg}} {{ activationEmail}} -->

  <label class="mb-0">Important Note: {{activationMsg}} ({{ activationEmail }}).
  </label>
  <div class="mb-0">
    <a href="#" (click)="verifyAccount()"> Verify account</a>
  </div>

  <!-- <div *ngIf="!showEmail" class="mb-05rem ml-4">
    <a href="#" (click)="resendActivationLink()">Resend Activation Link</a> &nbsp;&nbsp;
    <a href="#" (click)="updateEmail()">Update Email</a>
  </div> -->
  <!-- <div *ngIf="showEmail" class="mb-05rem ml-3">
    <form [formGroup]="updateEmailFrm" class="form-inline">
      <input type="text" class="form-control mr-3" placeholder="user@example.com" formControlName="email">
      <small class="form-text text-danger error-5"
             *ngIf="updateEmailFrm.controls['email'].invalid && updateEmailFrm.controls['email'].touched">
        Please enter valid email
      </small>
      <small class="form-text text-danger error-5"
             *ngIf="emailExist">
        {{emailExist}}
      </small>
      <button class="btn btn-primary" (click)="saveNewEmail(updateEmailFrm.value)" [disabled]="updateEmailFrm.invalid">
        Save
      </button>
      <button class="btn btn-secondary ml-2" (click)="cancelNewEmail()">Cancel</button>
    </form>
  </div> -->
</ngb-alert>
<!--end-->
<!--display success bar on resend ativation link-->

<!--display 2fa activation details-->
<ngb-alert class="alert-p1 alert-full text-center justify-content-center mb-0" *ngIf="twofa" (close)="closeClick()" [dismissible]="true">
  <label class="mb-0">{{twofa}}
  </label>&nbsp;
   <div class="mb-0">
    <a href="#" (click)="redirectToPath('/profile')">Change settings</a>
  </div>
</ngb-alert>
<!--end-->


<ngb-alert *ngIf="showOnResend" class="alert-success alert-full text-center justify-content-center mb-0" (close)="closeResendActivation()">
  <p>Email with activation link sent to {{activationEmail}}
  </p>
</ngb-alert>
<!--end-->
<div class="header navbar-light d-flex justify-content-between align-items-center navbar-expand-sm">
  <div class="d-flex">
    <a (click)="redirectToProduct()" class="logo">Netcore Email API</a>
    <a (click)="redirectToProduct()" class="logo-subtitle align-self-center"> {{subtitle}}</a>
  </div>
  <ul class="nav-right" *ngIf="hideHeaderRight; else defaultHeaderRight">
    <li>
      <button
        type="button"
        class="btn btn-secondary d-flex align-items-center"
        (click)="goToAccessManagement()">
        <i class="nxticon-settings-new align-self-center font-small nxt-pt-1"></i>
        <span class="ml-2">Settings</span>
      </button>
    </li>
  </ul>
  <ng-template #defaultHeaderRight>
  <ul class="nav-right">
    <li>
      <div id="zeda-widget-trigger" class="beamerTrigger pointer">
        <i class="nxticon-whatsnew font-large"></i>
        <span class="font-color-gray mr-4 pr-2">What's new</span>
      </div>
    </li>


    <!--<a href="javascript:void(0)" (click)="redirectToPath('/profile')">(Change)</a></li>-->
    <!--<li><strong>Credits: {{credits}}</strong></li>-->
    <!--commenting notificaton as discussed by Dibya-->
    <!--<li ngbDropdown placement="bottom-right">-->
    <!--<a ngbDropdownToggle class="notification" id="notification-bell" data-toggle="dropdown"-->
    <!--aria-expanded="false">-->
    <!--<i class="icon icon-notification"></i>-->
    <!--<span *ngIf="unreadCount >0"> {{unreadCount}}</span>-->
    <!--</a>-->
    <!--<div ngbDropdownMenu class="top-dropdown-menu notification-menu dropdown-menu" aria-labelledby="notification-bell">-->
    <!--<i class="dropdown-arr"></i>-->
    <!--<div class="notification-header clearfix">-->
    <!--<strong>Notifications</strong>-->
    <!--</div>-->
    <!--<div class="msg-list" *ngFor="let notification of notifications | slice : 0: 5">-->
    <!--<a href="#" (click)="notificationClick()" class="clearfix">-->
    <!--<div class="msg-area">-->
    <!--<div class="msg" [innerHTML]="notification.message"></div>-->
    <!--<span>{{notification.eventtime | fromNow}}</span>-->
    <!--</div>-->
    <!--</a>-->
    <!--</div>-->
    <!--<a href="#" (click)="notificationClick()" class="text-link-secondary">See all notifications</a>-->
    <!--</div>-->
    <!--</li>-->
    <!--commenting refferal from header as discussed by Dibya-->
    <!--<li *ngIf="pepipost">-->
    <!--<a class="text-link" href="#" (click)="redirectToPath('/referral')"><img src="assets/images/giphy.gif"-->
    <!--class="gift-icon">-->
    <!--Refer A Friend</a>-->
    <!--</li>-->
    <!--li *ngIf="pepipost && paid">
      <a class="premium_gift" href="#" (click)="openReferFriend()">Gift a premium subscription to your friends</a>
    </li-->
    <!-- <li *ngIf="back_to_falconide">
      <a class="premium_gift" href="https://app.pepipost.com/app/dashboard?appcue=-M3Q2ZJDjXhAbF72iat4">Switch To Falconide</a>
    </li> -->
    <!-- only display to the users which are allowed -->
    <!-- <li *ngIf="newUIDisplay">
      <div class="float-right btn-group btn-outline" ngbRadioGroup name="radioBasic" [ngModel]="newUIToggel"
                    data-toggle="buttons" id="radioBasic"
                    (ngModelChange)="onRadioChangeEvent($event)">
        <label ngbButtonLabel class="btn-primary">
            <input type="radio" ngbButton [value]="false"> Old Theme
        </label>
        <label ngbButtonLabel class="btn-primary">
            <input type="radio" ngbButton [value]="true"> New Theme
        </label>
      </div>
    </li> -->

    <li [hidden] = "productType == 'conv_apps'">
      <!-- (click)="redirectToPath('/profile')" -->
      <p class="h6 font-color-gray mb-0 time-zone" (click)="redirectToPath('/profile')">
        <span class="nxticon-time-zone font-large align-bottom pr-2"></span>
        <strong class=" font-weight-semibold">{{timzone}} </strong></p>
    </li>
    <!--<li [hidden]="newUserFlag">-->
    <!--<a class="text-link" href="https://app1.pepipost.com/index.php/home/index">Switch To Old</a>-->
    <!--</li>-->
    <li ngbDropdown placement="bottom-right" class="d-flex align-items-center">
      <img appGravatar [email]="email" [size]="150" class="img-fluid rounded-circle profile-align-left user-profile">
      <a ngbDropdownToggle class="user-profile" id="user-profile" data-toggle="dropdown"
         aria-expanded="false">
        <span class="user-name">
          {{username}}
          <ng-container *ngIf="parentUserName"><span class="font-small font-color-gray font-weight-normal">(Admin : {{parentUserName}})</span></ng-container>
        </span>
        <i class="parent-name"></i>

        <p class="demo-mode mb-0 mx-3"  *ngIf="globalMode === 'live'">
          <span class="mode-indicator live-mode"></span>
          <span class="font-color-gray"> Live </span>
        </p>

        <p class="demo-mode mb-0 mx-3" *ngIf="globalMode === 'sandbox'">
          <span class="mode-indicator test-mode" ></span>
          <span class="font-color-gray">Sandbox</span>
        </p>

      </a>

      <ul ngbDropdownMenu class="top-dropdown-menu profile-dropdown" aria-labelledby="user-profile">
        <!-- <li class="dropdown-item"><i class="dropdown-arr"></i></li> -->
        <li class="dropdown-item"><a routerLink="/profile/details">Profile</a></li>
        <!--li class="dropdown-item" *ngIf="newUIDisplay && newUIToggel == true">
          <a  href="javascript:void(0);" (click) = "onRadioChangeEvent(false)">Old Theme</a>
        </li>
        <li class="dropdown-item" *ngIf="newUIDisplay && newUIToggel == false">
          <a  href="javascript:void(0);" (click) = "onRadioChangeEvent(true)">New Theme</a>
        </li> -->
        <!-- Only V2 phase 2 toggle -->

        <!--li class="dropdown-item" *ngIf="newUIv2Display">
          <a  href="javascript:void(0);" (click) = "onv2click(true)">Switch to old Theme</a>
        </li-->
        <!-- end -->

        <!-- <li class="dropdown-item" > -->
        <li class="dropdown-item" *ngIf="switchAccount">
          <a  href="javascript:void(0);" (click) = "openAccountList()">Switch Account</a>
        </li>

        <!-- <li class="dropdown-item" [hidden]="globalMode === 'sandbox'">
          <a href="javascript:void(0);" (click)="changeMode('sandbox')">Sandbox Mode</a>
        </li> -->
        <li class="dropdown-item" [hidden]="globalMode === 'live'">
          <a href="javascript:void(0);" (click)="changeMode('live')">Live Mode</a>
        </li>
        <!-- <li *ngIf="pepipost" class="dropdown-item"><a href="#" (click)="redirectToPath('/referral')">Refer & Earn
          $1000</a>
        </li> -->
        <li class="dropdown-item"><a href="#" (click)="logout()">Log Out</a></li>
      </ul>
    </li>
  </ul>
  </ng-template>
</div>
</div>

<ng-template #accountListSection let-c="close" let-d="dismiss">
    <div class="modal-header">
    <h4 class="modal-title d-flex justify-content-between">Switch to subaccount
      <!-- <a type="button" (click)="d('Cross click')">
        <span aria-hidden="true"><i class="fas fa-times"></i></span>
      </a> -->
      <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
      </button>
    </h4>
    <p>Select desired account from following dropdown.</p>
  </div>
    <div class="modal-body">
      <div>
        <div class="form-group">
          <nxt-dropdown
            *ngIf="subAccountList"
            class="floatlabel-dropdown"
            [(ngModel)]="subaccountUsername"
            [options]="subAccountList"
            [config]="{ placeholder: 'Subaccount list', floatlabel: true, floatlabelText: 'Subaccount list', iconType: 'sharp-caret', searchable: true, searchPlaceholder: 'Search subaccount...', label: 'username', value: 'username' }"
            (selectionChange)="onChangeUsername($event)">
          </nxt-dropdown>
        </div>
        <div class="form-group">
          <button type="button" class="icon-primary-btn btn-primary" (click)="redirectToAccount(subaccountUsername)" [disabled]="isDisabled">Save</button>
          <button type="button" *ngIf="parentUserName" class="icon-primary-btn btn-secondary" (click)="redirectToAccount(parentUserName)">Back to master account</button>
        </div>
      </div>
    </div>
</ng-template>

<!-- <div class="header navbar-light navbar-expand-sm d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center">
      <a routerLink="/dashboard" class="logo">PepiPost</a>
      <div class="global-search">
          <input type="text" placeholder="Search for a campaign, contact or a template" />
        </div>
  </div>
  <div class="d-flex">
    <div class="header-raman-insights">
      <div class="raman-mascot-img">
        <img [src]="ramanMascotImg" />
      </div>
      <span class="raman-mascot-title">Insights</span>
      <span class="notification-count">2</span>
    </div>
    <div class="pepi-client">
        <img [src]="fi" alt="fi">
        <div class="pepi-client-details">
          <p class="pepi-client-name">Sendo India <span class="down-arrow"></span></p>
          <p class="demo-mode live-mode"><span class="mode-indicator"></span>Live</p>
        </div>
      </div>
  </div>
</div> -->

<!--bootstrap modal window to enter email id of referrer-->
<ng-template #referFriendPopup let-c="close" let-d="dismiss">
  <form [formGroup]="frmReferFriend">
    <div class="modal-header">
      <h4 class="modal-title">Gift a premium subscription to your friend
	<h6>You can send up to five gift subscriptions to your friends.</h6>
      </h4>
      <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label class="col-form-label bold-label" for="fname">Your name

        </label>
        <input type="text" placeholder="Type your name" id="fname" class="form-control" formControlName="fname" #fname>
        <small class="form-text text-danger"
               *ngIf="frmReferFriend.controls['fname'].touched && frmReferFriend.controls['fname'].invalid">Please enter
          your name.
        </small>

      </div>
      <div class="form-group">
        <label class="col-form-label bold-label" for="frndName">Your friend's name</label>
        <input type="text" placeholder="Type your friend's name" id="frndName" class="form-control" formControlName="frndName"
               #frndName>
        <small class="form-text text-danger"
               *ngIf="frmReferFriend.controls['frndName'].touched && frmReferFriend.controls['frndName'].invalid">Please
          enter
          your friend's name.
        </small>

      </div>
      <div class="form-group">
        <label class="col-form-label bold-label" for="email">Your friend's email address
        </label>
        <input type="text" placeholder="Type your friend's email address" id="email" class="form-control" formControlName="email" #email>
        <small class="form-text text-danger"
               *ngIf="frmReferFriend.controls['email'].touched && frmReferFriend.controls['email'].invalid">Please enter
          valid email.
        </small>

      </div>
      <app-alert *ngIf="referFrndMsg" [type]="referFrndType" [dismissible]="false" [value]="referFrndMsg"></app-alert>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="referFriend(fname.value,frndName.value,email.value)"
              [disabled]="frmReferFriend.invalid" id="btnEmailSend">Send
      </button>
      <button type="button" class="btn btn-secondary" (click)="c('Close click')" id="cancelEmail">Cancel</button>
    </div>
  </form>
</ng-template>


<!--bootstrap modal window to for Account verification -->
<ng-template #verifyAccountPopup let-c="close" let-d="dismiss">
  <!-- <form [formGroup]="verifyChangePwdForm"> -->
    <div *ngIf="!showEmail">
      <div class="modal-header pb-4">
      <h4 class="modal-title">Verify your account</h4>
      <button type="button" class="close m-4" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
      </button>
    </div>
    <div class="modal-body">

      <div class="form-group">
        <p class="font-weight-bold font-color-black font-medium">{{activationMsg}} ({{ activationEmail }}).</p>
        <p class="font-weight-semibold font-regular mb-0 font-color-gray"><i class="fa fa-info-circle" aria-hidden="true"></i> Please check your promotion/spam folder, if the email doesnt reach to your inbox.</p>
        <br/>
      </div>
      <div class="form-group">
        <button type="button" class="btn btn-secondary ml-0"
              (click)="resendActivationLink()">Resend Activation Link</button>
        <button type="button" class="btn btn-secondary"
              (click)="updateEmail()">Change email ID</button>
      </div>

    </div>
    <div class="modal-footer">

    </div>
  </div>


  <div *ngIf="showEmail">
      <div class="modal-header">
      <h4 class="modal-title">Change Email ID</h4>
      <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
      </button>
    </div>
    <div class="modal-body">

      <div class="form-group">
       <form [formGroup]="updateEmailFrm">
        <div>
          <div class="form-group">
            <div class="">
              <mat-form-field class="w-100">
                <input type="text" matInput placeholder="user@example.com" formControlName="email">
                </mat-form-field>
                <small class="form-text text-danger"
                       *ngIf="updateEmailFrm.controls['email'].invalid && updateEmailFrm.controls['email'].touched">
                  Please enter valid email
                </small>
                <small class="form-text text-danger"
                       *ngIf="emailExist">
                  {{emailExist}}
                </small>

            </div>
          </div>
          <div class="form-group">
            <button class="icon-primary-btn btn-primary" (click)="saveNewEmail(updateEmailFrm.value)" [disabled]="updateEmailFrm.invalid">
             Save
            </button>
            <button class="icon-primary-btn btn btn-secondary" (click)="cancelNewEmail()">Back</button>
          </div>
        </div>
      </form>
      </div>

    </div>
    <div class="modal-footer">

    </div>
  </div>
  <!-- </form> -->
</ng-template>
<!--end-->
<!--end-->



<!--bootstrap modal window for expired link for account activation-->
<ng-template #accountActicationExpiredLinkPopup let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title"></h4>
    <!-- <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
    </button> -->
  </div>
  <div class="modal-body text-center">
    <img [src]="deleteConfirmImg">
    <p class="mb-0 mt-3">
      <span><strong>This link has been expired</strong></span><br/><br/>
      <span>Please check your inbox for a new link to verify your account.</span>
    </p>

  </div>
  <div class="modal-footer m-auto">
    <button type="button" class="btn btn-secondary" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>
